const SubscriptionStatus = {
    EXPIRED: 0,
    ACTIVE: 1,
    SUSPENDED: 2,
    INACTIVE: 3,
};

export default SubscriptionStatus;
